// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"1ff1a6d8","207":"d3e91cc6","354":"d6608d3a","378":"031893f8","380":"8a37a537","672":"65f21ba1","749":"1dc39a78","755":"3281e46a","791":"6ba2c4f3","894":"3d229196","980":"1e842303"}[chunkId] + ".chunk.js";
};